PJQ.integrations = {
    views: {},
    models: {},
    collections: {}
}

PJQ.modules.budget = {
    routes: [
        {
            route: "budget",
            name: 'budget',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "budget"
                });
            }
        },
        {
            route: 'projects/:projectId/budget',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "budget");
            }
        },
        {
            route: 'projects/:projectId/costcodes',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "costcodes");
            }
        },
        {
            route: 'projects/:projectId/subjobs',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "subjobs");
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.budget.routes);
